import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { CommonServices } from 'src/app/Common/CommonServices';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { CardDetail, PaymentClient, User } from 'src/app/Services/WOWApi.Service';

@Component({
  selector: 'app-add-update-payment-method',
  standalone: false,
  templateUrl: './add-update-payment-method.component.html',
  styleUrl: './add-update-payment-method.component.css'
})
export class AddUpdatePaymentMethodComponent implements OnInit {
  private readonly customServices = inject(CustomServiceService);
  private readonly data = inject(MAT_DIALOG_DATA);
  private readonly commonServices = inject(CommonServices);
  private readonly paymentClient = inject(PaymentClient);
  private readonly dialog = inject(MatDialogRef<AddUpdatePaymentMethodComponent>);

  card: CardDetail | any = new CardDetail();
  Months: {month: number, name: string}[] = [
    {month: 1, name: 'January'},
    {month: 2, name: 'February'},
    {month: 3, name: 'March'},
    {month: 4, name: 'April'},
    {month: 5, name: 'May'},
    {month: 6, name: 'June'},
    {month: 7, name: 'July'},
    {month: 8, name: 'August'},
    {month: 9, name: 'September'},
    {month: 10, name: 'October'},
    {month: 11, name: 'November'},
    {month: 12, name: 'December'},
  ]
  Years: number[] = [];

  loggedUser: User;
  isEditing: boolean = false;

  ngOnInit(): void {
    this.dialog.addPanelClass('payment-method-dialog-panel');
    this.card.id = 0;
    this.loggedUser = this.customServices.GetLoggedInUser();
     if (this.loggedUser !== undefined && this.loggedUser !== null) {
      this.card.userId = this.loggedUser.id;
    }
    const curYear = moment(new Date()).year();
    this.Years.push(curYear);
    for(let i = 0; i < 25; i++) {
      this.Years.push(Number(curYear) + i + 1);
    }
    if (this.data !== undefined && this.data !== null && this.data.card !== undefined && this.data.card !== null) {
      this.card.id = this.data.card.id;
      this.card.cardHolderName = this.data.card.cardHolderName;
      this.card.cardExpiryMonth = this.data.card.cardExpiryMonth;
      this.card.cardExpiryYear = parseInt(this.data.card.cardExpiryYear);
      this.card.detailsAddedOn = this.data.card.detailsAddedOn;
      this.card.isActive = this.data.card.isActive;
      this.card.userId = this.data.card.userId;
      
      const cardValue = document.getElementById('cardNumber') as HTMLInputElement;
      cardValue.value = this.data.card.cardNumber;
      this.isEditing = true;
    }
  }

  onAddUpdateCard() {
    const cardValue = document.getElementById('cardNumber') as HTMLInputElement;
    this.card.cardNumber = cardValue.value;
    if (this.card.cardNumber === undefined) {
      this.commonServices.showMessage('Error', 'Please provide the card number.');
      return;
    }
    if (this.card.cardNumber.length < 19) {
      this.commonServices.showMessage('Error', 'Please provide the valid card number.');
      return;
    }
    if (this.card.cardNumber.length > 19)  {
      this.commonServices.showMessage('Error', 'Please provide valid 16 digit card number.');
      return;
    }
    if (this.card.cardExpiryMonth === undefined || this.card.cardExpiryMonth === null || this.card.cardExpiryMonth === '') {
      this.commonServices.showMessage('Error', 'Please provide valid card expiry Month.');
      return;
    }
    if (this.card.cardExpiryYear === undefined || this.card.cardExpiryYear === null || this.card.cardExpiryYear === 0 || this.card.cardExpiryYear === 'NaN') {
      this.commonServices.showMessage('Error', 'Please provide valid card expiry Year.');
      return;
    }
    if (this.card.cardHolderName === undefined || this.card.cardHolderName === null || this.card.cardHolderName === '') {
      this.commonServices.showMessage('Error', 'Please provide valid card holder name.');
      return;
    }
    
    const addApi = this.paymentClient.saveCardDetails(this.card);
    const updateApi = this.paymentClient.updateCardDetails(this.card.id, this.card);
    const api = this.isEditing ? updateApi : addApi;
    api.subscribe({
      next: data => {
        this.commonServices.showMessage('Success', `Card ${this.isEditing ? 'updated' : 'added'} successfully`);
        this.dialog.close('success')
      },
      error: (err: HttpErrorResponse) => {
        this.commonServices.showMessage('Error', err.message);
      }
    })
  }
}
